import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Flex, Text, Alert, AlertIcon } from '@chakra-ui/react';
import Pagination from '../../../shared/pagination/Pagination';
import Breadcrumbs from '../../../shared/breadcrumbs/Breadcrumbs';
import ShopItemOffersTable from './ShopItemOffersTable';
import { getAllShopItemOffers, updateShopItemOfferStatus } from '../../../../store/shopItemOffers/shopItemOffersSlice';
import { RulesWrapper } from '../rules/RulesStyle';
import theme from '../../../global/theme';

const ShopItemOffers = () => {
  const dispatch = useDispatch();
  const { adminOffers } = useSelector(state => state.shopItemOffers);
  const [page, setPage] = useState(1);

  useEffect(() => {
    dispatch(getAllShopItemOffers({ page, filter: JSON.stringify({}) }));
  }, [dispatch, page]);

  return (
    <RulesWrapper>
      <Breadcrumbs currentPage="عروض توفير المنتجات المطلوبة" pages={[{ name: 'لوحة التحكم', path: '/admin' }]} />
      {adminOffers.errors.length > 0 && (
        <Alert status="error" variant="left-accent" marginBottom={8}>
          <AlertIcon />
          {adminOffers.errors.map((e, i) => <Text key={i}>{e?.msg}</Text>)}
        </Alert>
      )}
      {adminOffers.data?.itemsCount > 0 ? (
        <ShopItemOffersTable
          data={adminOffers.data.data}
          page={page}
          handleUpdateStatus={(offer, status) => dispatch(updateShopItemOfferStatus({ id: offer._id, status }))}
        />
      ) : (
        <Flex textAlign="center" bg={theme.light} boxShadow={theme.shadow} height={200}
          alignItems="center" justifyContent="center" borderRadius={4}>
          <Text fontSize={18} color="gray.300" fontWeight="bold">لا توجد عروض</Text>
        </Flex>
      )}
      <Flex justifyContent="flex-end">
        <Pagination page={page} itemsCount={adminOffers.data?.itemsCount ?? 0} onChange={setPage} />
      </Flex>
    </RulesWrapper>
  );
};

export default ShopItemOffers;
